module.exports = __webpack_public_path__ + "static/media/IMG_TARUN.761191f5.jfif";